import { render, staticRenderFns } from "./DefaultContainer.vue?vue&type=template&id=58616bf4&"
import script from "./DefaultContainer.vue?vue&type=script&lang=js&"
export * from "./DefaultContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58616bf4')) {
      api.createRecord('58616bf4', component.options)
    } else {
      api.reload('58616bf4', component.options)
    }
    module.hot.accept("./DefaultContainer.vue?vue&type=template&id=58616bf4&", function () {
      api.rerender('58616bf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/DefaultContainer.vue"
export default component.exports